const frontendURL = '/app/email/';
const backendURL = '/api/messages/message/';
const name = 'Повідомлення';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: false,
};

export default instance;
